// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasksTagDropdownSelected {
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid var(--ta-border-primary);
}

.tasksTagDropdownTag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--ta-bg-secondary);
  border: 1px solid var(--ta-border-primary);
  color: var(--ta-text-primary);
  padding: 3px 6px 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.tasksTagDropdownTagText {
  line-height: 1.4;
}

.tasksTagDropdownTagRemove {
  background: none;
  border: none;
  color: var(--ta-text-tertiary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.15s ease;
}
.tasksTagDropdownTagRemove:hover {
  color: var(--ta-error);
}`, "",{"version":3,"sources":["webpack://./src/apps/TasksApp/components/TagDropdown.scss"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,iDAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,0CAAA;EACA,6BAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,4BAAA;AAAF;AAEE;EACE,sBAAA;AAAJ","sourcesContent":["// === TAG DROPDOWN ===\n.tasksTagDropdownSelected {\n  padding: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  border-bottom: 1px solid var(--ta-border-primary);\n}\n\n.tasksTagDropdownTag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: var(--ta-bg-secondary);\n  border: 1px solid var(--ta-border-primary);\n  color: var(--ta-text-primary);\n  padding: 3px 6px 3px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.tasksTagDropdownTagText {\n  line-height: 1.4;\n}\n\n.tasksTagDropdownTagRemove {\n  background: none;\n  border: none;\n  color: var(--ta-text-tertiary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: color 0.15s ease;\n\n  &:hover {\n    color: var(--ta-error);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
